/**
 * Authentication utilities
 *
 * パスワードをSessionStorageで管理
 */

const PASSWORD_KEY = 'viewer_password';

export function getPassword(): string | null {
  return sessionStorage.getItem(PASSWORD_KEY);
}

export function setPassword(password: string): void {
  sessionStorage.setItem(PASSWORD_KEY, password);
}

export function clearPassword(): void {
  sessionStorage.removeItem(PASSWORD_KEY);
}

export function hasPassword(): boolean {
  return !!getPassword();
}
